import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { fmtErr } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success("Welcome back!");
      nav("/portal");
    } catch (err) { toast.error(fmtErr(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  const input = "w-full bg-white border border-[#E5D8C1] px-4 py-3 focus:outline-none focus:border-[#D32F2F]";

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="login-root">
      <h1 className="font-heading text-5xl uppercase tracking-wide">Buyer login</h1>
      <p className="mt-3 text-[#5C5A56]">Approved wholesale buyers only.</p>
      <form onSubmit={submit} className="mt-8 bg-[#FDF4E3] border border-[#E5D8C1] p-8 space-y-4">
        <label className="block"><span className="text-xs uppercase tracking-widest">Email</span>
          <input required type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} className={input + " mt-2"} data-testid="login-email" />
        </label>
        <label className="block"><span className="text-xs uppercase tracking-widest">Password</span>
          <input required type="password" value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} className={input + " mt-2"} data-testid="login-password" />
        </label>
        <button type="submit" disabled={loading} className="w-full bg-[#D32F2F] text-white hover:bg-[#B71C1C] py-4 uppercase tracking-widest font-heading transition-transform hover:-translate-y-1 disabled:opacity-60 flex items-center justify-center gap-2" data-testid="login-submit">
          {loading && <Loader2 className="animate-spin" size={18} />} Sign in
        </button>
        <div className="text-center text-sm text-[#5C5A56]">
          Don&apos;t have an account? <Link to="/register" className="text-[#D32F2F] font-semibold" data-testid="login-goto-register">Create one</Link>
          <div className="mt-1"><Link to="/wholesale" className="text-[#1A1A1A] underline">Or apply as wholesaler first</Link></div>
        </div>
      </form>
    </div>
  );
}
